<template>	
	<img :src="notes1" @click="callcc" class="myimg">
</template>

<script>
	export default {
	  name: 'hot',	 
	  data(){
	  		return{			
	  		     notes1:require('@/assets/cctel.png')
	  		}  	 
		},
		methods:{
			callcc(){
				window.location.href = 'tel://4006600900' 
			}
		}
	  }
</script>
<style>
.myimg {
	margin-top:1px;
	max-width:100%;
}
</style>
